module.exports = __webpack_public_path__ + "img/logo.d3ac5c9e.svg";